import { Typography } from "knack-ui";
import { toast } from "react-toastify";
import SVG from "../SVG/SVG";

export const Failure = (title, subtitle) => {
  toast.error(
    <div>
      <div>
        <Typography variant="subtitle2" fontWeight="semibold">
          {title || "Error"}
        </Typography>
        {subtitle && (
          <Typography variant="caption" color="muted">
            {subtitle}
          </Typography>
        )}
      </div>
    </div>,
    {
      autoClose: true,
      icon: () => <SVG name="ExclamationFull" />
    }
  );
};
